export default path => () => import(`../../views/admin${path}.vue`);



// WEBPACK FOOTER //
// ./src/router/admin/view.js